import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { GeneralQuery, GeneralService } from '../../client/state';
import { onSideNavChange } from '../../core/animations';
import { AuthService } from '../../core/authentication/auth.service';
import { SparrowIconEnum } from '../../core/icons-registry';
import { ResponsiveDirective } from '../../shared/directives/responsive.directive';
import { ClientHeaderComponent } from '../client-header/client-header.component';
import { ClientNavbarComponent } from '../client-navbar/client-navbar.component';

@Component({
  selector: 'sparrow-client-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.scss'],
  animations: [onSideNavChange],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSidenavModule, ClientNavbarComponent, MatIconModule, RouterOutlet, ClientHeaderComponent, AsyncPipe],
})
export class ClientLayoutComponent extends ResponsiveDirective implements OnInit {
  isRootRoute: boolean;
  hasUserAnyAccess$: Observable<boolean>;

  readonly sideNavState = signal<boolean>(false);

  readonly SparrowIcon = SparrowIconEnum;

  constructor(
    private generalService: GeneralService,
    private authService: AuthService,
    private generalQuery: GeneralQuery,
    private router: Router,
  ) {
    super();
    this.isRootRoute = this.router.url === '/';
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isRootRoute = this.router.url === '/';
      }
    });
    this.hasUserAnyAccess$ = this.generalQuery.hasUserAnyAccess$;

    // load initial data for client
    this.authService.getUserLoginData().subscribe();
    this.generalService.getAttributes().subscribe();
    this.generalService.getOrgUnits().subscribe();
    this.generalService.getOperatorUsers().subscribe();
    this.generalService.getReductionReasons().subscribe();
    this.generalService.getUnitOfMeasure().subscribe();
    this.generalService.getCurrencies().subscribe();
    this.generalService.getOperatorErp().subscribe();
    this.generalService.getAccessPermissions();
    this.generalService.setUserPermissionAccess();
    this.generalService.setOperatorAttributes();
  }

  onSidenavToggle($event: MouseEvent) {
    this.sideNavState.update((value) => !value);
  }
}
